<template>
  <div>
    <div class="header border-bottom">
      <span>购物车</span>
    </div>
    <div class="content" v-for="item in list" :key="item.id">
      <img src="/static/img/购物车.png" alt="购物车">
      <p>{{item.tip}}</p>
      <router-link tag="button" to="/">去抢购</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyshopHeader',
  props: {
    list: Array
  }
}
</script>

<style scoped>
.header{ line-height: 44px;}
.header span{ font-size: 18px; width: 100%; text-align: center; display: block;}
.content img{ width: 35%; margin: 25px auto 0 auto; display: block;}
.content p{ text-align: center; margin-top: 5px; font-size: 16px;}
.content button{ border: 1px solid #e268a9; width: 50%; display: block; margin-top: 10px; margin-left: auto; margin-right: auto; color: #e268a9; background-color: #fff; font-size: 14px; line-height: 28px; border-radius: 3px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/empty_shopping/components/Header.vue